import type { ProductData } from "~/domains/product/types/ProductData";
import type { MMDFormValues } from "~/features/productDetails/components/MMDAssistant/MMDDialog";
import { useSelector } from "react-redux";
import { selectSearchQuery } from "~/features/search/redux/searchSelectors";

export const useSrpCmnLogic = (product: ProductData): Partial<MMDFormValues> => {
  const searchQuery = useSelector(selectSearchQuery);
  if (product.cmnSearchMatched) {
    return {
      customerMaterialNumbers: [searchQuery],
      filterOrder: ["customerMaterialNumbers"],
    };
  }
  return {};
};
